/** The colours NuLife PA's own screens are drawn in: near-white with olive and
 *  plum, from the hall's website mockup (a trial of C3's `hall-heritage` set,
 *  Drea 2026-10-26). One name for both token systems — the chassis's
 *  `data-nl-design` (the home screen) and booking-ui's `data-nl-theme` (every
 *  other screen). Crafting Comb's own screens do not use it. */
export const PA_THEME = "hall-heritage";
